/**
 * Application Constants
 *
 * Only the constants actually consumed by the app live here. (A large speculative
 * config catalogue — PAGINATION, DATE_FORMATS, TOAST_*, HTTP_STATUS, ROUTES, … —
 * was removed as dead code; grids/toasts/routes are configured inline where used.)
 */

// Session Configuration (consumed by AuthContext + services/api)
export const SESSION_CONFIG = {
  AUTO_LOGOUT_TIME: 86400000, // 24 hours in ms
  TOKEN_COOKIE_NAME: "biteg-app-token",
  // "Angemeldet bleiben": lifetime (seconds) of the PERSISTENT token cookie so it
  // survives a browser restart. Without the flag the cookie has no maxAge and is
  // a session cookie the browser drops on close. 30 days.
  REMEMBER_ME_MAX_AGE: 60 * 60 * 24 * 30,
  REFRESH_INTERVAL: 300000, // 5 minutes
  // sessionStorage key set by the api interceptor on a 401 (expired session) so
  // the login screen can explain the redirect after the full-page reload.
  SESSION_EXPIRED_FLAG: "biteg-session-expired",
};
